"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _relativeTimeFormatTime = require("./relativeTime.formatTime.helper");
var _relativeTime = _interopRequireDefault(require("./relativeTime.shape"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var RelativeTime = function RelativeTime(_ref) {
  var then = _ref.then,
    now = _ref.now,
    locale = _ref.locale,
    uniqueID = _ref.uniqueID;
  return _react.default.createElement("time", {
    dateTime: new Date(then).toISOString(),
    title: (0, _relativeTimeFormatTime.formatAbsoluteTime)(then),
    "data-testid": uniqueID
  }, (0, _relativeTimeFormatTime.formatRelativeTime)({
    then: then,
    now: now,
    locale: locale
  }));
};
RelativeTime.propTypes = {
  then: _propTypes.number.isRequired,
  now: _propTypes.number.isRequired,
  locale: _relativeTime.default,
  uniqueID: _propTypes.string
};
var _default = RelativeTime;
exports.default = _default;